import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CardProduct from './CardProduct.js';
import { addToCart } from '../actions';
import { useStyles } from '../Component/Style/StyleOrder';
import './Products.css'
import { Alert, AlertTitle, LoadingButton } from '@mui/lab';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
//config
import Config from "../config/config";
//actions
import buscarFilialPorCodigoFilial from "../actions/cadastro/buscar-filial-por-codigo-filial.js";
import listaProdutosPrecosFilial from "../actions/produtos/buscar-precos-filial.js";
import actionListaProdutosByReduzidoECorProduto from '../actions/produtos/lista-produtos-por-reduzido-e-cor-produto';
import listaOutrosTamanhos from '../actions/produtos/lista-outros-tamanhos'
import actionIsConfereEstoqueLoja from "../actions/config/actionIsConfereEstoqueLoja.js";
import listaProdutosFiliais from '../actions/produtos/lista-produtos-filiais';
import listaOutrasCores from '../actions/produtos/lista-outras-cores';

import { Toolbar, AppBar, Slide, Stack, Backdrop, LinearProgress, Box, Button, Dialog, DialogActions, DialogTitle, FormControlLabel, Checkbox, Typography, Avatar, Badge, Container, Divider, IconButton, Grid, Card } from "@mui/material";

//componets
import SemResultados from "../Component/Page/SemResultados.js";
import LoadingModal from "./LoadingModal/index";

//actions
import Actions from "../constants/Actions";

//services
import { getDataUsuario } from '../services/auth'
import v2_actionBuscarProduto from '../actions/v2/produtos/v2_actionBuscarProduto.js';
import v2_actionCoresProdutos from '../actions/v2/produtos/v2_actionCoresProdutos.js';
import v2_actionTamanhosProdutos from '../actions/v2/produtos/v2_actionTamanhosProdutos.js';
import v2_actionProdutosLojas from '../actions/v2/produtos/v2_actionProdutosLojas.js';
import v2_actionPrecosProdutos from '../actions/v2/produtos/v2_actionPrecosProdutos.js';
import { agruparPorGrade, formatarCodigoFilial, transformarEmArray } from '../utils/functions.js';
import ModalProduto from './ModalProduto.js';



const Produtos = ({ abrirDialog, product }) => {
  const [verProduto, setVerProduto] = useState('');
  const [outrasCoresProduto, setOutrasCoresProduto] = useState([])
  const [outrosProdutos, setOutrosProdutos] = useState([])
  const [outrosTamanhos, setOutrosTamanhos] = React.useState([]);
  const [filiaisProdutos, setFiliaisProdutos] = React.useState([]);
  const [open, setOpen] = useState(false);
  const [tamanhoProduto, SetTamanhoProduto] = React.useState('');
  const [corProduto, setCorProduto] = React.useState('');
  const [filialProduto, setFilialProduto] = React.useState('');
  const [parcelaSelecionada, setParcelaSelecionada] = React.useState('');
  const [modalTravaCarrinho, setModalTravaCarrinho] = React.useState(false);
  const [modalMudouPreco, setModalMudouPreco] = React.useState(false);
  const [loadingModal, setLoadingModal] = React.useState(false);
  const [isProdutoApto, setIsProdutoApto] = React.useState(false);
  const [produtoAbaixoEstoque, setprodutoAbaixoEstoque] = React.useState(false);
  const [precoProduto, setPrecoProduto] = React.useState('');
  const [isConfereEstoqueLoja, setIsConfereEstoqueLoja] = React.useState(false);
  const [isEstoque, setIsEstoque] = React.useState(false);
  const dispatch = useDispatch();


  const [loadingVerificaPreco, setLoadingVerificaPreco] = useState(false);

  //stare
  const products = useSelector(state => state.products);
  const cepOrigemProduto = useSelector(state => state.cepOrigemProduto);
  const cartItems = useSelector(state => state.cartItems);


  const handleChangeParcelas = (event) => {
    setParcelaSelecionada(event.target.value);
  };

  const handleChangeIsProdutoApto = (event) => {
    setIsProdutoApto(event.target.checked);
  };


  const Teste = (product) => {
    let item = {
      product_image: product.images.length > 0 ? product.images[0]._id : null,
      product_id: product._id,
      variant_id: null,
      quantity: 1,
      discount_total: 0,
      name: product.name,
      regular_price: precoProduto,
      price: precoProduto,
      price_total: precoProduto,
      sku: product.sku,
      tax_class: 0,
      tax_total: 0,
      produto: product.produto,
      cor_produto: corProduto,
      grade: tamanhoProduto,
      variant_name: null,
      weight: product.weight,
      dimension: product.dimension,
      images: product.images,
      filial: formatarCodigoFilial(filialProduto),
      desc_cor_produto: product.desc_cor_produto,
      length: product.dimensions.length,
      heigth: product.dimensions.height,
      width: product.dimensions.width,
      use_descricao: product.use_descricao,
      use_referencia: product.use_referencia,
      use_cod_cor_produto: product.use_cod_cor_produto,
      use_descricao: product.use_cod_filial,
      use_cor_produto: product.use_cor_produto

    }

    if (cartItems.length === 0) {
      dispatch(addToCart(item));
      dispatch({ type: Actions.CEP_ORIGEM_PRODUTO, cepOrigemProduto: filialProduto });
      setVerProduto('');
      setCorProduto('');
      SetTamanhoProduto('');
      setFilialProduto('');
      setFiliaisProdutos([]);
      setOutrosTamanhos([]);
      setOutrasCoresProduto([]);
      setOpen(false);
      dispatch({ type: Actions.DRAWER_CARRINHO, drawerCarrinho: true })

    } else {
      if (filialProduto === cepOrigemProduto) {
        dispatch(addToCart(item));
        dispatch({ type: Actions.CEP_ORIGEM_PRODUTO, cepOrigemProduto: filialProduto });
        setVerProduto('');
        setCorProduto('');
        SetTamanhoProduto('');
        setFilialProduto('');
        setFiliaisProdutos([]);
        setOutrosTamanhos([]);
        setOutrasCoresProduto([]);
        setOpen(false);
        dispatch({ type: Actions.DRAWER_CARRINHO, drawerCarrinho: true })
      } else {
        setModalTravaCarrinho(true)
      }
    }

  }




  const handleEscolheuCor = async (cores, referencia, cor) => {
    setCorProduto(cor);
    setOutrosTamanhos([]);
    SetTamanhoProduto(null);
    setFilialProduto(null);
    setLoadingModal(true);

    let querys = `?referencia=${referencia}&cor_produto=${cor}`;
    const res = await v2_actionBuscarProduto(querys);
    if (res.status === 200 && res.data.produto) {
        setVerProduto(res.data.produto);
    }
    
    const tamanhos = await v2_actionTamanhosProdutos(`?referencia=${referencia}&cor_produto=${cor}&loja=${getDataUsuario().filial}`);
    if (tamanhos.status === 200 && tamanhos.data.produtos.length > 0) {
      const agrupadosPorGrade = agruparPorGrade(tamanhos.data.produtos);
      const resultadoFinal = transformarEmArray(agrupadosPorGrade);
      setOutrosTamanhos(resultadoFinal);
      setIsEstoque(true);
    } else {
      setIsEstoque(false);
    }
    setLoadingModal(false);


  };

  const handleEscolheuFilial = async (data) => {
    setLoadingVerificaPreco(true)
    setprodutoAbaixoEstoque(false);
    if (data.estoque === 1) {
      setprodutoAbaixoEstoque(true);
    } else if (verProduto.grupo_produto === 'BOTA' || verProduto.linha === 'FEMININO') {
      setprodutoAbaixoEstoque(true);
    } else {
      setIsProdutoApto(true);
    }


    const filialEscolhida = data.loja;

    const precos = await v2_actionPrecosProdutos(`?referencia=${verProduto.use_referencia}&cor_produto=${verProduto.use_cod_cor_produto}&tamanho=${tamanhoProduto}&loja=${filialEscolhida}`);

    if(precos.status === 200 && precos.data.preco) {
      setPrecoProduto(precos.data.preco);
      setFilialProduto(filialEscolhida);
    }
    setLoadingVerificaPreco(false);

  };

  const handleEscolheuTamanho = async (data) => {
    setprodutoAbaixoEstoque(false);
    if (data.estoque === 1) {
      setprodutoAbaixoEstoque(true);
    } else {
      setIsProdutoApto(true);
    }
    setFilialProduto('');
    SetTamanhoProduto(data.grade);
    const produtosLojas = await v2_actionProdutosLojas(`?referencia=${verProduto.use_referencia}&cor_produto=${verProduto.use_cod_cor_produto}&tamanho=${data.grade}&loja_vendedor=${getDataUsuario().filial}`);
    if(produtosLojas.status === 200 && produtosLojas.data.produtos.length > 0) {
      setFiliaisProdutos(produtosLojas.data.produtos);
    }


  };

  const handleClickOpen = async (data) => {
    const { produto } = data;
    setOpen(true)
    setIsProdutoApto(null);
    setLoadingModal(true);

    let querys = `?referencia=${produto.use_referencia}&cor_produto=${produto.use_cod_cor_produto}`;
    const res = await v2_actionBuscarProduto(querys);
    if (res.status === 200 && res.data.produto) {
      
        setVerProduto(res.data.produto);
    
        const cores = await v2_actionCoresProdutos(`?referencia=${produto.use_referencia}`);
        if (cores.status === 200) {
          setOutrasCoresProduto(cores.data.cores);
          await handleEscolheuCor(cores.data.cores, produto.use_referencia, produto.use_cod_cor_produto);
        }
        setLoadingModal(false);
    }
  }

  const handleClickClose = () => {
    setOpen(false);
    setVerProduto('');
    setPrecoProduto('')
    setCorProduto('');
    SetTamanhoProduto('');
    setFilialProduto('');
    setFiliaisProdutos([]);
    setOutrosTamanhos([]);
    setOutrasCoresProduto([]);
    setIsProdutoApto(false);
  };

  ///modals
  const handleCloseModalTravaCart = () => {
    setModalTravaCarrinho(false);
  };

  const handleCloseModalMudouPreco = () => {
    setModalMudouPreco(false);
  };


  useEffect(() => {
    actionIsConfereEstoqueLoja().then(res => {
      setIsConfereEstoqueLoja(res.data.data);
    }).catch(err => console.log(err))

  }, []);


  return (
    <>
      {products.length > 0 ? (
        <Box
          sx={{
            display: 'grid',
            gap: 1,
            gridTemplateColumns: {
              xs: 'repeat(2, 1fr)',
              sm: 'repeat(3, 1fr)',
              md: 'repeat(5, 1fr)',
              lg: 'repeat(6, 1fr)',
              xl: 'repeat(8, 1fr)',
            },
          }}
        >
          {products.map(data =>
            data ? (
              <CardProduct
                key={data.produto._id}
                product={data.produto}
                verProdutoProps={() => handleClickOpen(data)}
              />
            ) : null
          )}
        </Box>
      ) : (
        <SemResultados />
      )}


      <Dialog
        open={modalTravaCarrinho}
        onClose={handleCloseModalTravaCart}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">NÃO FECHAMOS VENDA COM PRODUTOS DE OUTRAS FILIAIS.</DialogTitle>

        <DialogActions>
          <Button onClick={handleCloseModalTravaCart} color="primary">
            Fechar
          </Button>

        </DialogActions>
      </Dialog>

      <Dialog
        open={modalMudouPreco}
        onClose={handleCloseModalMudouPreco}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">ENCONTRAMOS OUTRO PREÇO PRA ESSA FILIAL!</DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseModalMudouPreco} color="primary">
            OK
          </Button>

        </DialogActions>
      </Dialog>

      <ModalProduto
        open={open}
        handleClickClose={handleClickClose}
        produto={verProduto}
        onLoadProduct={produto => {
          setVerProduto(produto)
        }}

      />

    </>
  )

}


export default Produtos
